import * as React from "react";
const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 12, viewBox: "0 0 6 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.15493e-08 6L6 7.15493e-08L6 12L7.15493e-08 6Z", fill: "currentColor" }));
export default SvgArrowLeft;
